import { EditorState } from 'draft-js';
import {
  defaultPeriod,
  defaultStates,
  questionsSortStates,
} from '../constants/common';
import {
  SET_SEARCH_VAL,
  SET_FILTER_VISIBLE,
  SET_SELECTED_QUESTION,
  SET_PERIOD,
  SET_TYPES,
  SET_STATES,
  SET_COMPANIES,
  SET_STREETS,
  SET_HOUSES,
  SET_ADDRESSES,
  RESET_FILTER,
  SET_IS_HTML,
  SET_LOCAL_FILES,
  SET_EDITOR_STATE,
  SET_EDITOR_LINK_MODAL_DATA,
  SET_MESSAGE_AREA_STATE,
  RESET_AREA_EDITOR_STATES,
  SET_ANSWER_STATUS,
  SET_CLOSE_QUESTION_REJECTED,
  RESET_QUESTIONS_STORE,
  SET_QUESTIONS_SORT_DATA,
  SET_QUESTIONS_SAVED_DATA,
  SET_IMPORTANT_QUESTIONS_FIRST,
  SET_QUESTION_REACTION,
  SET_NOTIFICATION_QUESTION,
  SET_EDITOR_PHONE_MODAL_DATA
} from './actionsTypes';
import { decorators, initEditorLinkModalData, initEditorPhoneModalData } from '../../../components/MessageEditor';

const defaultFiltersState = {
  period: defaultPeriod,
  types: [],
  states: defaultStates,
  companies: [],
  streets: [],
  houses: [],
  addresses: [],
  answerStatus: undefined,
  reaction: undefined,
  closeQuestionRejected: false,
};

const defaultEditorState = EditorState.createEmpty(decorators);

const initState = {
  searchVal: '',
  filterVisible: false,
  selectedQuestion: null,
  messageAreaState: '',
  isHtml: false,
  localFiles: [],
  editorPhoneModalData: initEditorPhoneModalData,
  editorLinkModalData: initEditorLinkModalData,
  editorState: defaultEditorState,
  sortData: questionsSortStates.dateDesc,
  importantQuestionsFirst: false,
  notificationQuestion: undefined,
  ...defaultFiltersState,
};

const questionsReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case SET_SEARCH_VAL:
      return {
        ...state,
        searchVal: payload,
      };
    case SET_FILTER_VISIBLE:
      return {
        ...state,
        filterVisible: payload,
      };
    case SET_SELECTED_QUESTION:
      return {
        ...state,
        selectedQuestion: payload,
      };
    case SET_PERIOD:
      return {
        ...state,
        period: payload,
      };
    case SET_TYPES:
      return {
        ...state,
        types: payload,
      };
    case SET_STATES:
      return {
        ...state,
        states: payload,
      };
    case SET_COMPANIES:
      return {
        ...state,
        companies: payload,
      };
    case SET_STREETS: {
      const newState = {
        ...state,
        streets: payload,
      };

      if (state.streets[0] !== payload[0]) {
        newState.houses = [];
        newState.addresses = [];
      }

      return newState;
    }
    case SET_HOUSES: {
      const newState = {
        ...state,
        houses: payload,
      };

      if (state.houses[0] !== payload[0]) {
        newState.addresses = [];
      }

      return newState;
    }
    case SET_ADDRESSES:
      return {
        ...state,
        addresses: payload,
      };
    case RESET_FILTER:
      return {
        ...state,
        ...defaultFiltersState,
        searchVal: '',
        selectedQuestion: null,
      };
    case SET_IS_HTML:
      return {
        ...state,
        isHtml: payload,
      };
    case SET_LOCAL_FILES:
      return {
        ...state,
        localFiles: payload,
      };
    case SET_EDITOR_STATE:
      return {
        ...state,
        editorState: payload,
      };
    case SET_EDITOR_LINK_MODAL_DATA:
      return {
        ...state,
        editorLinkModalData: payload,
      };
    case SET_EDITOR_PHONE_MODAL_DATA:
      return {
        ...state,
        editorPhoneModalData: payload,
      };
    case SET_MESSAGE_AREA_STATE:
      return {
        ...state,
        messageAreaState: payload,
      };
    case RESET_AREA_EDITOR_STATES:
      return {
        ...state,
        messageAreaState: '',
        editorState: defaultEditorState,
      };
    case SET_ANSWER_STATUS:
      return {
        ...state,
        notificationQuestion: undefined,
        answerStatus: payload,
      };
    case SET_CLOSE_QUESTION_REJECTED:
      return {
        ...state,
        notificationQuestion: undefined,
        closeQuestionRejected: payload,
      };
    case SET_QUESTIONS_SORT_DATA:
      return {
        ...state,
        sortData: payload,
      };
    case SET_QUESTIONS_SAVED_DATA:
      return {
        ...state,
        ...payload,
      };
    case SET_IMPORTANT_QUESTIONS_FIRST:
      return {
        ...state,
        importantQuestionsFirst: payload,
      };
    case SET_QUESTION_REACTION:
      return {
        ...state,
        notificationQuestion: undefined,
        reaction: payload,
      };
    case SET_NOTIFICATION_QUESTION:
      return {
        ...state,
        notificationQuestion: payload,
      };
    case RESET_QUESTIONS_STORE:
      return initState;
    default:
      return state;
  }
};

export default questionsReducer;
